import { useRouter } from '@tanstack/react-router';
import { createContext, use } from 'react';
import { graphql, useFragment, useMutation } from 'react-relay';
// import { fetchQuery } from 'relay-runtime';
import type { processDefinitionsTemplateQueryFragment$key } from './__generated__/processDefinitionsTemplateQueryFragment.graphql';
import type { processDefinitionsTemplateQueryDeleteMutation } from './__generated__/processDefinitionsTemplateQueryDeleteMutation.graphql';
// import type { processDefinitionsTemplateQueryXmlQuery } from './__generated__/processDefinitionsTemplateQueryXmlQuery.graphql.ts';

// https://github.com/jakst/tanstack-router-relay/blob/main/src/routes/index.lazy.tsx

// PANDING/LOADING STATE
// TSR - https://github.com/TanStack/router/blob/92c6c2b1ff3bbf661c6aed7fbda84c8233d0a30e/examples/react/kitchen-sink-file-based/src/routes/__root.tsx
// TSR - https://tanstack.com/router/latest/docs/framework/react/api/router/matchRouteComponent
// RR - https://www.geeksforgeeks.org/how-relay-is-different-from-redux/

export const ProcessDefinitionsTemplateQueryCtx = createContext<
    processDefinitionsTemplateQueryFragment$key | null | undefined
>(null);

const processDefinitionsTemplateQueryFragment = graphql`
    fragment processDefinitionsTemplateQueryFragment on ProcessDefinitionPage {
        content {
            createdAt
            id
            definitionKey
            definitionName
            definitionVersion
            modifiedAt
            startWhen
            status
        }

        pageInfo {
            ...listPaginationQueryFragment
        }
    }
`;

export const useProcessDefinitionsTemplateQueryFragment = () =>
    useFragment(processDefinitionsTemplateQueryFragment, use(ProcessDefinitionsTemplateQueryCtx));

export const useProcessDefinitionsTemplateQueryFragmentRef = (
    fragmentRef?: processDefinitionsTemplateQueryFragment$key
) => useFragment(processDefinitionsTemplateQueryFragment, fragmentRef);

const gqlDelete = graphql`
    mutation processDefinitionsTemplateQueryDeleteMutation($ids: [ID!]!) {
        deleteProcessDefinitions(ids: $ids)
    }
`;

export const useProcessDefinitionsTemplateDelete = () =>
    useMutation<processDefinitionsTemplateQueryDeleteMutation>(gqlDelete);

export const useProcessDefinitionsTemplateQueryRefresh = (): (() => void) => {
    const router = useRouter();
    return () => {
        router.invalidate();
    };
};
